export const enum ClientContactsType {
    EMERGENCY = 0,
    LANDLORD = 1,
    KEY_SUPPLIER = 2,
    FRANCHISOR = 3,
    EMERGENCY2 = 4,
}



// WEBPACK FOOTER //
// ./src/app/models/client-contacts/client-contacts.type.ts